export default "__VITE_ASSET__B9OmT$fD__"